import React, { FunctionComponent, useEffect, useState } from "react";
import styles from "./AppVersion.module.css";
import images from "../../assets/images";
import {
  Button,
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import {
  AppVersionObjectType,
  AppVersionList,
  AppVersionMenu,
  CustomTextField,
  InputPropsForAddAffiliates,
} from "../../helper";
import { useForm } from "react-hook-form";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_CURRENT_APP_VERSION, UPDATE_VERSION, UPDATE_VERSION_NOTIFICATION } from "./api/TnCs&PPQuery";
import ToasterWithMessage from "../../components/shared-components/toaster";

const InputField = CustomTextField();

const defaultValues = {
  appOsName: "",
  appVersion: "",
  forceUpdate: true,
};

interface FormdataProps {
  appOsName: string;
  appVersion: string;
  forceUpdate: boolean;
}

const AppVersion: FunctionComponent = () => {
  const { dropdownIcon } = images;
  const [disableBtn, setDisableBtn] = useState<boolean>(true);
  const [anchorElApp, setAnchorElApp] = useState<EventTarget | null>(null);
  const [appVerisonList, setAppVersionList] = useState<AppVersionList>();
  const [appversionOsName, setAppVersionOsName] = useState<string>("");
  const [valueradio, setValueRadio] = useState<string>("");
  const [appversionInput, setAppVersionInput] = useState<string>("");
  const [initialValueForappVersion, setinitialValueForappversion] =
    useState<string>("");
  const [initialValueForceupdate, setinitialValueForceupdate] =
    useState<boolean>();

  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
    watch,
    setError,
    clearErrors
  } = useForm({
    defaultValues: defaultValues,
    mode: "onChange",
  });

  const watchFields = watch(["appOsName", "appVersion", "forceUpdate"]);
  const { error, success } = ToasterWithMessage();

  const open = Boolean(anchorElApp);

  const [getCurrentAppVersion, { loading }] = useLazyQuery(
    GET_CURRENT_APP_VERSION,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (data) {
          setAppVersionList(data.app_version_info);
        }
      },
    }
  );

  const [updateVersion, { loading: updateLoading }] = useMutation(
    UPDATE_VERSION_NOTIFICATION,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        if (data) {
          success("Updated Successfully");
          setinitialValueForappversion(appversionInput)
          setinitialValueForceupdate(valueradio === 'Yes' ? true : false )
          // handleReset()
        }
      },
      onError: (err) => {
        error("Something went Wrong!");
      },
    }
  );

  const handleClickOpenMenu = (e: React.MouseEvent<HTMLInputElement>) => {
    setAnchorElApp(e.currentTarget);
    getCurrentAppVersion();
  };

  const handleCloseMenu = () => {
    setAnchorElApp(null);
  };

  const handleSelectappversion = (appVersion: AppVersionObjectType) => {
    setAnchorElApp(null);
    setAppVersionOsName(appVersion.app_os_name);
    setValueRadio(appVersion.app_should_force_update ? "Yes" : "No");
    setAppVersionInput(appVersion.app_version);
    setValue("appOsName", appVersion.app_os_name);
    setValue("appVersion", appVersion.app_version);
    setValue("forceUpdate", appVersion.app_should_force_update);
    setinitialValueForappversion(appVersion.app_version);
    setinitialValueForceupdate(appVersion.app_should_force_update);
  };

  const handleChangeAppVersion = (e: React.ChangeEvent<HTMLInputElement>) => {
    clearErrors('appVersion');
    const input = e.target.value;
    const regexPattern = /^(?!0)(?!.*\.\.)[0-9.]*$/;
    if (regexPattern.test(input) && input.length <= 10) {
      setAppVersionInput(e.target.value);
      setValue("appVersion", e.target.value);
    } else {
      setAppVersionInput(appversionInput);
      setValue("appVersion", appversionInput);
    }
  };

  const handleChangeForceUpdate = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValueRadio(event.target.value);
    setValue("forceUpdate", event.target.value === "Yes" ? true : false);
  };

  const onSubmitAppversion = (data: FormdataProps) => {
    const regexPattern = /^(?!\.)(?!.*\.$)[0-9.]*$/;
    if (data.appOsName.trim() !== "" && data.appVersion.trim() !== "") {
      if(regexPattern.test(data?.appVersion.trim())){
      updateVersion({
        variables: {
          appOsName: data.appOsName,
          appVersion: data.appVersion,
          shouldForceUpdate: data.forceUpdate,
        },
      });
    }else{
       setError('appVersion',{
        type: 'manual',
        message: "Enter a valid App Version",
      })
    }
    }
  };

  const handleReset = () => {
    setAppVersionOsName("");
    setAppVersionInput("");
    setValueRadio("");
    setValue("appOsName", "");
    setValue("appVersion", "");
  };

  useEffect(() => {
    if (appversionOsName !== "") {
      if (
        watch("appVersion") === initialValueForappVersion &&
        watch("forceUpdate") === initialValueForceupdate
      ) {
        setDisableBtn(true);
      } else if (
        watch("appOsName").trim() === "" ||
        watch("appVersion").trim() === "" ||
        valueradio.trim() === ""
      ) {
        setDisableBtn(true);
      } else {
        setDisableBtn(false);
      }
    } else {
      if (
        watch("appOsName").trim() === "" ||
        watch("appVersion").trim() === "" ||
        valueradio.trim() === ""
      ) {
        setDisableBtn(true);
      } else {
        setDisableBtn(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchFields]);

  return (
    <>
      {updateLoading ? (
        <div className={styles.circularProgressappVersion}>
          <CircularProgress color="primary" size={35} />
        </div>
      ) : (
        <form onSubmit={handleSubmit(onSubmitAppversion)}>
          <div className={styles.maindiv}>
            <div className={styles.seconddiv}>
              <div className={styles.textFieldFullMainappversion}>
                <div className={styles.titlePlaceholderappversion}>
                  <b className={styles.AppOs}>App Platform</b>
                </div>
                <div
                  className={styles.textFieldappversion}
                  onClick={handleClickOpenMenu}
                >
                  <div className={styles.container1version}>
                    <div
                      className={
                        appversionOsName === ""
                          ? styles.select
                          : styles.appVersionSelect
                      }
                    >
                      {appversionOsName ? appversionOsName : "--Select--"}
                    </div>
                    <img
                      className={styles.sharpOutlineDropdown}
                      alt="dropdownIcon"
                      src={dropdownIcon}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.textFieldFullMainappversion}>
                <div className={styles.titlePlaceholderappversion}>
                  <b className={styles.AppOs}>App Version</b>
                </div>
                <InputField
                  variant="outlined"
                  data-testid="appVersion"
                  fullWidth
                  {...register("appVersion", {
                    required: "App version is required",
                  })}
                  value={appversionInput}
                  placeholder={"Enter App Version"}
                  InputProps={{
                    style: InputPropsForAddAffiliates,
                  }}
                  error={Boolean(errors?.appVersion?.message)}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleChangeAppVersion(e)
                  }
                />
                <span className={styles.errorMsgStyle}>
                  {errors?.appVersion?.message}
                </span>
              </div>

              <div className={styles.textFieldFullMainappversion}>
                <div className={styles.titlePlaceholderappversion}>
                  <b className={styles.AppOs}>Force Update</b>
                </div>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={valueradio}
                  onChange={handleChangeForceUpdate}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div>
                    <FormControlLabel
                      value="Yes"
                      control={
                        <Radio
                          sx={{
                            color: "#B9BDC6",
                            "&.Mui-checked": {
                              color: "#5D75F8",
                            },
                          }}
                        />
                      }
                      label=""
                    />
                    <span className={styles.radiovalid}>Yes</span>
                  </div>
                  <div>
                    <FormControlLabel
                      value="No"
                      control={
                        <Radio
                          sx={{
                            color: "#B9BDC6",
                            "&.Mui-checked": {
                              color: "#5D75F8",
                            },
                          }}
                        />
                      }
                      label=""
                    />
                    <span className={styles.radiovalid}>No</span>
                  </div>
                </RadioGroup>
              </div>
            </div>

            <div className={styles.ctaContainer}>
              <div className={styles.buttonStyle} onClick={handleReset}>
                <Button
                  classes={{ root: styles.separateStyleforcancelReferral }}
                  fullWidth
                  disableRipple
                >
                  Reset
                </Button>
              </div>
              <div
                className={
                  disableBtn ? styles.disabledButton : styles.updateButtonStyle
                }
              >
                <Button
                  classes={{
                    root: disableBtn
                      ? styles.separateStyledisabledUpdateBtn
                      : styles.separateStyleReferral,
                  }}
                  disableRipple
                  fullWidth
                  type="submit"
                  disabled={disableBtn}
                >
                  Update
                </Button>
              </div>
            </div>
          </div>
          <AppVersionMenu
            anchorElApp={anchorElApp}
            open={open}
            handleCloseMenu={handleCloseMenu}
            appVerisonList={appVerisonList}
            handleSelectappversion={handleSelectappversion}
            loading={loading}
          />
        </form>
      )}
    </>
  );
};

export default AppVersion;
